import { Geo } from '../types';
import { createRequestAtom } from '../utils/atoms/request-atom';

export const geoAtom = createRequestAtom<Geo>();
